import { get, post } from '@/utils/request1';

export const usersLogin = (data) => post('user/login',data); // 登录
export const usersRegister = (data) => post('user/register',data); // 注册
export const sendEmailCode = (data) => post('ems/send',data); // 发送邮箱验证码
export const usersForgotPassword = (data) => post('user/forgotpwd',data); // 忘记密码
